export default "__VITE_ASSET__Bsw4ugfu__"